import useAPIClient from "../../core/services/API/hooks/useAPIClient";
import useCacheQuery, {CacheQueryOpts, CacheQueryOutput} from "../../core/services/query/hooks/useCacheQuery";
import BookingItem from "../types/BookingItem";

type Output = BookingItem[];

export default function useGetBookingItems (
    bookingId: any,
    options?: CacheQueryOpts
): CacheQueryOutput<Output> {
    const client = useAPIClient();
    return useCacheQuery<Output>(
        ["basket-items", bookingId],
        () => {
            if (null === bookingId) {
                throw new Error('Error getting booking ID');
            }
            return client.get<any>(`bookings/${bookingId}/rooms`);
        },
        options
    );
}